import {
  HttpErrorResponse,
  HttpInterceptorFn,
  HttpStatusCode,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { catchError } from 'rxjs';

import { RoutingService } from '../services/routing.service';

import { ToastService } from '../services/toast.service';
import { AppActions } from '../../app.actions';
import { SILENT_REQUEST } from '../http/silent-request.context';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const store = inject(Store);
  const toastService = inject(ToastService);

  const isSilent = req.context.get(SILENT_REQUEST);

  return next(req)
      .pipe(
          catchError((error: HttpErrorResponse) => {
            if (error.status === HttpStatusCode.Unauthorized) {
              store.dispatch(new AppActions.ClearSession());
              void router.navigate([RoutingService.LOGIN], {
                queryParams: { returnUrl: router.url },
              });
              for (const message of extractMessages(error)) {
                void toastService.error(message);
              }
            }

            if (isSilent) {
              throw error;
            }

            if (error.status === 0) {
              void toastService.error('Sem conexão. Tente novamente.');
            } else if (error.status >= HttpStatusCode.InternalServerError) {
              void toastService.error('Erro no servidor. Tente mais tarde.');
            } else if (error.status >= HttpStatusCode.BadRequest) {
              for (const message of extractMessages(error)) {
                void toastService.error(message);
              }
            }

            throw error;
          }),
      );
};

function extractMessages(error: HttpErrorResponse): string[] {
  const fallback = 'Falha na requisição';
  const body = error.error;

  if (!body || typeof body !== 'object') {
    return [fallback];
  }

  if ('errors' in body) {
    const errors = body.errors;

    if (Array.isArray(errors)) {
      const list: string[] = [];
      for (const item of errors) {
        if (typeof item === 'string') {
          list.push(item);
        }
      }
      if (list.length > 0) {
        return list;
      }
    } else if (errors && typeof errors === 'object') {
      const list: string[] = [];
      for (const key of Object.keys(errors)) {
        const value = errors[key];
        if (Array.isArray(value)) {
          for (const item of value) {
            if (typeof item === 'string') {
              list.push(item);
            }
          }
        }
      }
      if (list.length > 0) {
        return list;
      }
    }
  }

  if ('message' in body && typeof body.message === 'string') {
    return [body.message];
  }

  return [fallback];
}
